<div class="skewed-bg edu-bg">
  <div id="education-content">
    <div class="content-description">
      <h2 class="section-header">EDUCATION</h2>
      <p>In this section my core skills as a software developer</p>
    </div>

    <div class="schools">
      <h1>Master of Science - Technology (2010-2017) </h1>
      <div class="content">
        <div class="degree-content">
          <h2> Tampere University of Technology (Master's Degree)</h2>
          <p>Major (Extensive): Communication Systems and Networks 50 ECTS, Grade: Excellent (5)
            <br> Minor: Wireless Communications 42 ECTS, Grade: Excellent (5)
            <!-- <br> -->
            <br> Master's Thesis 30 ECTS, Grade Very Good (4)
            <br> + Core Common Studies and Elective Studies
          </p>
          <br>
          <p>
            <!-- <a href="documents/Master_thesis.pdf">Link to my Master's Thesis pdf-file</a> -->
            <!-- <br> -->
            Subject: Comparison of Windowed OFDM AND Fast-Convolution based Filtered OFDM (Written in English)</p>
          <h2> Tampere University of Technology (Bachelor's Degree)</h2>
          <p>Major: Communication Engineering 28 ECTS, Grage: Good (3)
            <br>Minor: Software Systems 25 ECTS, Grage: Very Good (4)
            <br>Common Core Studies 113 ECTS, Grade Good (3)
            <!-- <br> -->
            <br>Bachelor's Thesis 8 ECTS, Grade: Good (3)
            <br> + Elective Studies
          </p>
          <br>
          <p>
            <!-- <a href="documents/Bachelor_thesis.pdf">Link to my Bachelor's Thesis pdf-file</a> -->
            <!-- <br>  -->
            Subject: Progress of IPv6 Innovation (Written in Finnish)</p>
        </div>
        <!-- <div class="degree-image">
          <img src="../../assets/images/tut.jpg" alt="Tampere University of Technology">
        </div> -->
      </div>

      <h1>Exchange Student Year (2013-14)</h1>
      <div class="content">
        <div class="degree-content">
          <h2> Budapest University of Technology and Economics</h2>
          <p>
            I studied Telecommunications and Communication system cources and also a couple of
            other courses for general education. I earned 40 ECTS
            (European Credit Transfer and Accumulation System) during one semester.
          </p>
        </div>
        <!-- <div class="degree-image">
          <img src="../../assets/images/bme.jpg" alt="Budapest University of Technology and Economics" />
        </div> -->
      </div>


      <h1>Undergraduate (2007-2009)</h1>
      <div class="content">
        <div class="degree-content">
          <h2>Jyväskylän normaalikoulu - High School for Athletes</h2>
          <br />
          <p> Subjects:
            <br />
            <br />Mathematics, Grade: Eximia cum lau­de ap­pro­ba­tur
            <br />Physics, Grade: Cum lau­de ap­pro­ba­tur
            <br />English Language, Grade: Ap­pro­ba­tur
            <br />Swedish Language, Cum lau­de ap­pro­ba­tur
            <br />Mother Tongue (Finnish), Cum lau­de ap­pro­ba­tur
            <br /> <br />
            Bonus: I was a part of the High School Basketball team, which won the Finnish High School Championship of Basketball (2008-2009)
          </p>
        </div>
        <!-- <div class="degree-image">
          <img src="../../assets/images/norssi.jpg" alt="Jyväskylän normaalikoulu">
        </div> -->
      </div>
    </div>
  </div>
